import { create } from 'zustand';

export type ToastVariant = 'default' | 'success' | 'error';

export interface Toast {
  id: string;
  title: string;
  description?: string;
  variant: ToastVariant;
}

export interface UIState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
}

let toastCounter = 0;

const SIDEBAR_KEY = 'v3_sidebar_open';

function getSavedSidebarState(): boolean {
  try {
    const saved = localStorage.getItem(SIDEBAR_KEY);
    return saved === null ? true : saved === 'true';
  } catch {
    return true;
  }
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: getSavedSidebarState(),
  toasts: [],

  toggleSidebar: () => set((state) => {
    const next = !state.sidebarOpen;
    localStorage.setItem(SIDEBAR_KEY, String(next));
    return { sidebarOpen: next };
  }),

  setSidebarOpen: (open: boolean) => {
    localStorage.setItem(SIDEBAR_KEY, String(open));
    set({ sidebarOpen: open });
  },

  addToast: (toast) => {
    const id = `toast-${++toastCounter}-${Date.now()}`;
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id }],
    }));
  },

  removeToast: (id: string) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));
